
import { useState } from "react"
import { romansOption, romansUpgrade } from "../../../../data/upgrade/romans"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const RomansUpgrade = (props) => {
    const selectList = romansOption
    const lvl = Array.from({ length: 20 }, (_, index) => ({ id: index + 1, name: `Level ${index + 1}` }));

    const [selectValue, setSelectValue] = useState({name:"", lvl:"1"})
    const handleSelectName = event => {
        setSelectValue(prevState => ({ name: event.target.value, lvl: prevState.lvl }));
    } 
    const handleSelectLvl = event => {
        setSelectValue(prevState => ({ ...prevState, lvl: event.target.value }));
    }
    
      
    function vypis(){
        const selectedRomanUpgrade = romansUpgrade[selectValue.name - 1][selectValue.lvl-1]
        const item =[{id:1,
                      name: romansOption[selectValue.name - 1].name + " " + selectedRomanUpgrade.level ,
                      wood: selectedRomanUpgrade.wood,
                      clay: selectedRomanUpgrade.clay,
                      iron: selectedRomanUpgrade.iron,
                      crop: selectedRomanUpgrade.crop,
                      all: selectedRomanUpgrade.all}]
        props.addItem(item[0])
    }
    

    
    return(
        <div>
            <ListSelect label="...choose a trop" selectList={selectList} handleSelectValue={handleSelectName} />
            <ListSelect label="...choose a level" selectList={lvl} handleSelectValue={handleSelectLvl}/>
            {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}

        </div>
    )
}
export default RomansUpgrade